const state = {
  data: null
};

// getters
const getters = {
  periods: (state, state_getters, store, store_getters) => {
    if (state.data == null) {
      return state.data;
    }
    state.data.forEach(v => {
      try {
        v.translations.forEach(t => {
          if (t.locale === store_getters["locale"]) {
            v.name = t.value;
            throw new Error("Founded");
          }
        });
      } catch (e) {}
    });
    return state.data;
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  setData(state, data) {
    state.data = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
